export type UiLanguage = 'de' | 'en';

const messages = {
  de: {
    tileView: 'Kachel-Ansicht',
    flowView: 'Fließtext-Ansicht',
    print: 'Drucken',
    printTooltip: 'Browser-Druckdialog öffnen',
    pdfDownload: 'Briefing als PDF herunterladen',
    pdfFailed: 'PDF-Download fehlgeschlagen.',
    pdfFailedRetry: 'PDF-Download fehlgeschlagen. Bitte versuchen Sie es erneut.',
    createdOn: 'Erstellt am',
    created: 'Erstellt:',
    quality: 'Qualität:',
    legalBar: 'KI-generierte Orientierungshilfe · Keine Versicherungsberatung gem. § 34d GewO',
    refundNotice: (score: number) =>
      `Qualitätsscore: ${score}/10 — Dein Credit wurde automatisch zurückgebucht, da das Briefing die Mindestqualität nicht erreicht hat.`,
    introduction: 'Einleitung',
    toc: 'Inhalt',
    tocButton: 'Inhaltsverzeichnis',
    navigation: 'Navigation',
  },
  en: {
    tileView: 'Tile view',
    flowView: 'Continuous text view',
    print: 'Print',
    printTooltip: 'Open browser print dialog',
    pdfDownload: 'Download briefing as PDF',
    pdfFailed: 'PDF download failed.',
    pdfFailedRetry: 'PDF download failed. Please try again.',
    createdOn: 'Created on',
    created: 'Created:',
    quality: 'Quality:',
    legalBar: 'AI-generated guidance · Not insurance advice under § 34d GewO',
    refundNotice: (score: number) =>
      `Quality score: ${score}/10 — Your credit was refunded automatically because the briefing did not reach the minimum quality.`,
    introduction: 'Introduction',
    toc: 'Contents',
    tocButton: 'Table of contents',
    navigation: 'Navigation',
  },
} as const;

export function getBriefingViewMessages(language: UiLanguage = 'de') {
  return messages[language] ?? messages.de;
}
